module.exports = __webpack_public_path__ + "static/media/05.Devanna Kamath Receiving Award.23934987.jpg";